// extracted by css-extract-rspack-plugin
export default {"modal":"gMHxKJBGJWszle2h","alert":"X5KhE04b5RAQO_9Y","alertHeading":"t7Lz6PFL5oYdo7BJ","alertBody":"fNOtmNozyYUtDyQo","sectionHeading":"YXSvmiY76vMmcZ8q"};